import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Injectable, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import * as i1 from 'rxjs';
import { shareReplay, throwError } from 'rxjs';
import { take, catchError, map, filter } from 'rxjs/operators';
import { __classPrivateFieldGet } from 'tslib';

// token to access a stream with the information you need
const PWA_MANIFEST = new InjectionToken('PWA_MANIFEST');

class PwaManifestModule {
    static forRoot(manifestUrl = './manifest.webmanifest') {
        return {
            ngModule: PwaManifestModule,
            providers: [
                {
                    provide: PWA_MANIFEST,
                    deps: [HttpClient],
                    useFactory: (http) => {
                        return http.get(manifestUrl).pipe(shareReplay(1), take(1), catchError((error) => {
                            return throwError(() => 'can t load manifest file');
                        }));
                    },
                },
            ],
        };
    }
}
PwaManifestModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PwaManifestModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestModule, imports: [CommonModule, HttpClientModule] });
PwaManifestModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestModule, imports: [CommonModule, HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, HttpClientModule],
                }]
        }] });

var _PwaManifestService_instances, _PwaManifestService_init, _PwaManifestService_createMetaElement, _PwaManifestService_createDomIcons, _PwaManifestService_createIconLinkElement;
class PwaManifestService {
    constructor(document, manifest$) {
        this.document = document;
        this.manifest$ = manifest$;
        _PwaManifestService_instances.add(this);
        this.shortName$ = this.manifest$.pipe(map((manifest) => manifest?.short_name));
        this.name$ = this.manifest$.pipe(map((manifest) => manifest?.name));
        this.description$ = this.manifest$.pipe(map((manifest) => manifest?.description));
        this.icons$ = this.manifest$.pipe(map((manifest) => manifest?.icons));
        this.screenshots$ = this.manifest$.pipe(map((manifest) => manifest?.screenshots));
        this.themeColor$ = this.manifest$.pipe(map((manifest) => manifest?.theme_color));
        this.display$ = this.manifest$.pipe(map((manifest) => manifest?.display));
        __classPrivateFieldGet(this, _PwaManifestService_instances, "m", _PwaManifestService_init).call(this);
    }
}
_PwaManifestService_instances = new WeakSet(), _PwaManifestService_init = function _PwaManifestService_init() {
    this.manifest$
        .pipe(filter((manifest) => !!manifest), take(1))
        .subscribe((manifest) => {
        __classPrivateFieldGet(this, _PwaManifestService_instances, "m", _PwaManifestService_createDomIcons).call(this);
        __classPrivateFieldGet(this, _PwaManifestService_instances, "m", _PwaManifestService_createMetaElement).call(this, 'theme-color', manifest.theme_color);
        __classPrivateFieldGet(this, _PwaManifestService_instances, "m", _PwaManifestService_createMetaElement).call(this, 'apple-mobile-web-app-title', manifest.name);
    });
}, _PwaManifestService_createMetaElement = function _PwaManifestService_createMetaElement(name, content) {
    const htmlMetaElement = this.document.createElement('meta');
    htmlMetaElement.name = name;
    htmlMetaElement.content = content;
    this.document.getElementsByTagName('head')[0].appendChild(htmlMetaElement);
}, _PwaManifestService_createDomIcons = function _PwaManifestService_createDomIcons() {
    this.manifest$.pipe(take(1)).subscribe((manifest) => {
        ['icon', 'apple-touch-icon'].forEach((rel) => {
            manifest.icons.forEach((appIcon) => {
                __classPrivateFieldGet(this, _PwaManifestService_instances, "m", _PwaManifestService_createIconLinkElement).call(this, appIcon, rel);
            });
        });
    });
}, _PwaManifestService_createIconLinkElement = function _PwaManifestService_createIconLinkElement(appIcon, rel) {
    const htmlLinkElement = this.document.createElement('link');
    const url = appIcon.src;
    htmlLinkElement.rel = rel;
    htmlLinkElement.type = appIcon.type;
    htmlLinkElement.href = url;
    htmlLinkElement.setAttribute('sizes', appIcon.sizes);
    this.document.getElementsByTagName('head')[0].appendChild(htmlLinkElement);
    return url;
};
PwaManifestService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestService, deps: [{ token: DOCUMENT }, { token: PWA_MANIFEST }], target: i0.ɵɵFactoryTarget.Injectable });
PwaManifestService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: PwaManifestService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1.Observable, decorators: [{
                    type: Inject,
                    args: [PWA_MANIFEST]
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { PwaManifestModule, PwaManifestService };
